
function generatingLayerId(type: string, id: any) {
    const sourceId = `${type}#${id}`;
    const layerId = `${type}#${id}-layer`;
    return { sourceId, layerId };
  };

  export {generatingLayerId};